/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Client } from './Client';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
    ClientToJSONTyped,
} from './Client';

/**
 * 
 * @export
 * @interface GtaRate
 */
export interface GtaRate {
    /**
     * 
     * @type {number}
     * @memberof GtaRate
     */
    id: number;
    /**
     * 
     * @type {Client}
     * @memberof GtaRate
     */
    client?: Client;
    /**
     * 
     * @type {string}
     * @memberof GtaRate
     */
    gta_group: string;
    /**
     * 
     * @type {string}
     * @memberof GtaRate
     */
    status?: GtaRateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GtaRate
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof GtaRate
     */
    gta_sort_index?: number;
    /**
     * 
     * @type {number}
     * @memberof GtaRate
     */
    daily_hire_rate: number;
}


/**
 * @export
 */
export const GtaRateStatusEnum = {
    Active: 'ACTIVE',
    Deleted: 'DELETED'
} as const;
export type GtaRateStatusEnum = typeof GtaRateStatusEnum[keyof typeof GtaRateStatusEnum];


/**
 * Check if a given object implements the GtaRate interface.
 */
export function instanceOfGtaRate(value: object): value is GtaRate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('gta_group' in value) || value['gta_group'] === undefined) return false;
    if (!('daily_hire_rate' in value) || value['daily_hire_rate'] === undefined) return false;
    return true;
}

export function GtaRateFromJSON(json: any): GtaRate {
    return GtaRateFromJSONTyped(json, false);
}

export function GtaRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): GtaRate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'client': json['client'] == null ? undefined : ClientFromJSON(json['client']),
        'gta_group': json['gta_group'],
        'status': json['status'] == null ? undefined : json['status'],
        'description': json['description'] == null ? undefined : json['description'],
        'gta_sort_index': json['gta_sort_index'] == null ? undefined : json['gta_sort_index'],
        'daily_hire_rate': json['daily_hire_rate'],
    };
}

export function GtaRateToJSON(json: any): GtaRate {
    return GtaRateToJSONTyped(json, false);
}

export function GtaRateToJSONTyped(value?: GtaRate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'client': ClientToJSON(value['client']),
        'gta_group': value['gta_group'],
        'status': value['status'],
        'description': value['description'],
        'gta_sort_index': value['gta_sort_index'],
        'daily_hire_rate': value['daily_hire_rate'],
    };
}

